module.exports = __webpack_public_path__ + "img/45.f0f27098.jpg";